const decimalRound = require('./decimalRound');

const PIXEL_ROUND_PRECISION = 1;

exports.ACCEPTABLE_ERROR = 1 / (10 ** PIXEL_ROUND_PRECISION);

exports.pixelRound = rawValue => decimalRound(rawValue, PIXEL_ROUND_PRECISION);
